import axios from '../../utils/AxiosWrapper';
export const Type = {

    //ADD
    ADD_CLIENT_CALL: 'ADD_CLIENT_CALL',
    ADD_CLIENT_SUCCESS: 'ADD_CLIENT_SUCCESS',
    ADD_CLIENT_FAILED: 'ADD_CLIENT_FAILED',

    //GET
    GET_CLIENT_READ_CALL: 'GET_CLIENT_READ_CALL',
    GET_CLIENT_READ_SUCCESS: 'GET_CLIENT_READ_SUCCESS',
    GET_CLIENT_READ_FAILED: 'GET_CLIENT_READ_FAILED',

    //DELETE
    DELETE_CLIENT_CALL: 'DELETE_CLIENT_CALL',
    DELETE_CLIENT_SUCCESS: 'DELETE_CLIENT_SUCCESS',
    DELETE_CLIENT_FAILED: 'DELETE_CLIENT_FAILED',

    //REGION
    GET_REGION_TYPE_CALL: 'GET_REGION_TYPE_CALL',
    GET_REGION_TYPE_SUCCESS: 'GET_REGION_TYPE_SUCCESS',
    GET_REGION_TYPE_FAILED: 'GET_REGION_TYPE_FAILED',

    //CLIENTGROUP
    GET_CLIENTGROUP_TYPE_CALL: 'GET_CLIENTGROUP_TYPE_CALL',
    GET_CLIENTGROUP_TYPE_SUCCESS: 'GET_CLIENTGROUP_TYPE_SUCCESS',
    GET_CLIENTGROUP_TYPE_FAILED: 'GET_CLIENTGROUP_TYPE_FAILED',

    //SEASON
    GET_SEASON_TYPE_CALL: 'GET_SEASON_CALL',
    GET_SEASON_TYPE_SUCCESS: 'GET_SEASON_SUCCESS',
    GET_SEASON_TYPE_FAILED: 'GET_SEASON_FAILED',

    //SET
    SET_CLIENT_ROW_IN_REDUCER: 'SET_CLIENT_ROW_IN_REDUCER',
    SET_INITIAL_STATE: 'SET_INITIAL_STATE',
};

export function setInitialState(component) {
    return (dispatch) => {
        dispatch({
            type: Type.SET_INITIAL_STATE,
            data: component
        });
    }
}

export function getRegionType() {
    return (dispatch) => {
        dispatch({
            type: Type.GET_REGION_TYPE_CALL
        });

        axios.get('api/region/filter_region')
            .then(function (response) {
                dispatch({
                    type: Type.GET_REGION_TYPE_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_REGION_TYPE_FAILED
                });
            });
    }
}

export function getClientGroupType() {
    return (dispatch) => {
        dispatch({
            type: Type.GET_CLIENTGROUP_TYPE_CALL
        });

        axios.get('api/region/filter_klijent_grupa')
            .then(function (response) {
                dispatch({
                    type: Type.GET_CLIENTGROUP_TYPE_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_CLIENTGROUP_TYPE_FAILED
                });
            });
    }
}

export function getSeasonType() {
    return (dispatch) => {
        dispatch({
            type: Type.GET_SEASON_TYPE_CALL
        });

        axios.get('api/season/filter_sezona')
            .then(function (response) {
                dispatch({
                    type: Type.GET_SEASON_TYPE_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_SEASON_TYPE_FAILED
                });
            });
    }
}


export function getClients(state, instance) {
    return (dispatch) => {
        dispatch({
            type: Type.GET_CLIENT_READ_CALL
        });

        var config = {
            params: {
                page: state.page,
                pageSize: state.pageSize,
                sorted: state.sorted,
                filtered: state.filtered
            }
        };
        axios.get('api/klijent/read', config)
            .then(function (response) {
                dispatch({
                    type: Type.GET_CLIENT_READ_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.GET_CLIENT_READ_FAILED
                });
            });
    }
}

export function deleteClient(selection) {
    return (dispatch) => {
        dispatch({
            type: Type.DELETE_CLIENT_CALL,
        });

        axios.post(`api/klijent/delete`, { selection: selection })
            .then(function (response) {
                dispatch({
                    type: Type.DELETE_CLIENT_SUCCESS,
                    data: response.data,
                    forDelete: selection
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.DELETE_CLIENT_FAILED
                });
            });
    }
}

export function addClient(clientObj) {
    return (dispatch) => {
        dispatch({
            type: Type.ADD_CLIENT_CALL
        });

        axios.post('api/klijent/create', clientObj)
            .then(function (response) {
                dispatch({
                    type: Type.ADD_CLIENT_SUCCESS,
                    data: response.data
                });
            })
            .catch(function (error) {
                dispatch({
                    type: Type.ADD_CLIENT_FAILED
                });
            });
    }
}


export function setRowInReducer(rowInfo) {
    return (dispatch) => {
        dispatch({
            type: Type.SET_CLIENT_ROW_IN_REDUCER,
            rowInfo: rowInfo
        })
    }
}